export default [
  { index: "journal", label: "Journal" },
  { index: "lessons", label: "Lessons" },
  { index: "community", label: "Community" },
  { index: "general", label: "General" },
];
